/**
 * OneMobile "GET OUR APP NOW" floating QR defaults to bottom-right in app config.
 * Keep it as a bottom-left widget, suppress the full-screen QR popup, and give
 * mobile shoppers a direct app-store CTA instead of asking them to scan a QR.
 */
(function () {
  const STYLE_ID = 'hok-om-position-left';
  const LINK_CLASS = 'hok-om-download-link';
  const IOS_APP_URL = 'https://apps.apple.com/us/app/house-of-kpop/id6755711082';
  const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=io.onemobile.houseofkpop';
  const CSS = `
    /* Floating app widget only. */
    [data-om-version].flex-col {
      right: auto !important;
      left: max(1rem, var(--om-popup-distance, 16px)) !important;
    }

    /* Suppress the full-screen app-download popup/backdrop; keep the widget visible. */
    [data-om-version].w-full {
      display: none !important;
      opacity: 0 !important;
      pointer-events: none !important;
      visibility: hidden !important;
    }

    .${LINK_CLASS} {
      align-items: center;
      background: linear-gradient(135deg, #b8e7ff 0%, #a9c8ff 48%, #d7ccff 100%);
      border: 1px solid rgba(130, 53, 151, 0.24);
      border-radius: 8px;
      color: #202223 !important;
      display: flex;
      font-size: 13px;
      font-weight: 900;
      gap: 10px;
      justify-content: space-between;
      letter-spacing: 0.06em;
      line-height: 1.1;
      padding: 12px 14px;
      text-decoration: none !important;
      text-transform: uppercase;
      width: 100%;
    }

    .${LINK_CLASS}::after {
      content: "→";
      font-size: 20px;
      line-height: 1;
    }

    .${LINK_CLASS}:focus-visible {
      outline: 2px solid #823597;
      outline-offset: 3px;
    }

    .hok-om-widget-trigger {
      padding: 0 !important;
    }

    .hok-om-widget-trigger > :not(.${LINK_CLASS}) {
      display: none !important;
    }

    .hok-om-widget-card .${LINK_CLASS} {
      margin-top: 14px;
    }

    @media (max-width: 749px) {
      [data-om-version].flex-col {
        max-width: min(176px, calc(100vw - 2rem));
      }

      /* Tighten the floating app pill to match the welcome pill on mobile */
      .${LINK_CLASS} {
        gap: 7px;
        padding: 9px 12px;
        font-size: 11.5px;
        letter-spacing: 0.04em;
        width: 100%;
        max-width: min(176px, calc(100vw - 2rem));
      }

      .${LINK_CLASS}::after {
        font-size: 16px;
      }

      .hok-om-widget-card {
        display: none !important;
      }
    }
  `;

  function appDownloadUrl() {
    const ua = navigator.userAgent || '';
    if (/android/i.test(ua)) return ANDROID_APP_URL;
    if (/(iphone|ipad|ipod)/i.test(ua)) return IOS_APP_URL;
    if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return IOS_APP_URL;
    if (/macintosh/i.test(ua)) return IOS_APP_URL;
    return ANDROID_APP_URL;
  }

  function makeLink() {
    const link = document.createElement('a');
    link.className = LINK_CLASS;
    link.href = appDownloadUrl();
    link.rel = 'noopener';
    link.target = '_blank';
    link.textContent = 'Download the app';
    link.addEventListener('click', function (event) {
      event.stopPropagation();
    });
    return link;
  }

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function shiftWidget(host) {
    const root = host.shadowRoot;
    if (!root) return;

    if (!root.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    }

    const card = Array.from(root.querySelectorAll('div')).find(function (element) {
      return textOf(element).startsWith('get our app now scan the qr code below');
    });

    if (card) {
      card.classList.add('hok-om-widget-card');
      if (!card.querySelector('.' + LINK_CLASS)) {
        card.appendChild(makeLink());
      }
    }

    const trigger = Array.from(root.querySelectorAll('.cursor-pointer')).find(function (element) {
      return textOf(element) === 'get our app now';
    });

    if (trigger) {
      trigger.classList.add('hok-om-widget-trigger');
      if (!trigger.querySelector('.' + LINK_CLASS)) {
        trigger.appendChild(makeLink());
      }
    }
  }

  function scan() {
    document.querySelectorAll('om-download-extension').forEach(shiftWidget);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
